<template>
    <v-container>
        <v-card outlined>
        <v-card-subtitle class="pb-0">
            
                <v-row>
                <v-col><DatePicker label="ตั้งแต่วันที่" @dateFormatted="setDateFrom" ></DatePicker></v-col>
                <v-col><DatePicker label="ถึงวันที่" @dateFormatted="setDateTo" ></DatePicker></v-col>
                <v-col><v-text-field  @keyup.enter.native="search"  v-model="receiveNo" label="เลขที่ใบรับอะไหล่" placeholder=" " outlined></v-text-field></v-col>
                <v-col class="text-right">
                    <v-row>
                        <v-btn  class="ma-2" color="primary" small @click="search"><v-icon>search</v-icon> ค้นหา</v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </v-card-subtitle>
    </v-card>
    <v-data-table
        v-model="selectedItem"
        :headers="headers"
        :items="items"
        class="pt-5"
        item-key="receivePartsId"
        show-select
        fixed-header
        height="350"
    >
        <template v-slot:top>
            <v-toolbar-title><v-btn v-if="selectedItem.length > 0"  class="ma-2" color="primary" small @click="deleteSelected"><v-icon>delete</v-icon> ลบรายการที่เลือก</v-btn></v-toolbar-title>
                <v-dialog v-model="viewDialog">
                    <ViewParts ref="viewParts" :id="itemId"  @closeViewParts="closeViewParts"></ViewParts>
                </v-dialog>
                    
            </template>

            <template v-slot:item.action="{ item }">
                <v-icon
                    v-if="item.jobNo == undefined || item.jobNo.length == 0"
                    small
                    @click="editData(item)"
                >
                    edit
                </v-icon>
                <v-icon
                    v-else
                    small
                    @click="editData(item)"
                >
                    search
                </v-icon>
                &nbsp;
                <v-icon
                    small
                    @click="deleteData(item)"
                >
                    delete
                </v-icon>
            </template>
         <!--
         <template v-slot:top>
                <v-dialog v-model="dialog" max-width="400px">
                    <v-container>
                        <v-card>
                        <v-card-title>รับอะไหล่</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-form ref="form" v-model="valid" lazy-validation>
                                <v-text-field v-model="receiver" outlined placeholder=" " label="ผู้รับอะไหล่"></v-text-field>
                            </v-form>
                        </v-card-text>
                        <v-card-actions class="text-right">
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="save">บันทึก</v-btn>
                            <v-btn color="primary" @click="close"> ยกเลิก</v-btn>
                        </v-card-actions>  
                    </v-card>
                    </v-container>
                </v-dialog>
                    
            </template>
           
        <template v-slot:item.action="{ item }">
                <v-icon
                    small
                    @click="editData(item)"
                >
                    edit
                </v-icon>
            </template>
            -->
    </v-data-table>
    </v-container>
</template>

<script>

import DatePicker from '@/components/Shared/DatePicker'
import {listStockPartsByReceiveNo, deleteStockParts} from '@/api/stock/stock-parts-api.js'
import ViewParts from './ViewParts'
import numeral from 'numeral'

export default {
    name: 'SearchReceive',
    components: {
        DatePicker,
        ViewParts
    },
    watch: {
        branchCode(val) {
            if (val) {
                this.search();
            }
        }
    },
    props: ["branchCode"],
    data: () => ({
        selectedItem: [],
        viewDialog: false,
        valid: false,
        headers: [
            {text: "เลขที่ใบรับอะไหล่", value: "receiveNo", width: '20%'},
            {text: "เลขที่ใบสั่งซ่อม", value: "jobNo", width: '20%'},
            {text: "ทะเบียน", value: "licenseNo", width: '15%'},
            {text: "วันที่รับอะไหล่", value: "receiveDate", width: '15%'},
            {text: "ยอดรวม", value: "netAmountDisplay", width: '15%'},
         //   {text: "ผู้รับ", value: "receiver"},
            {text: 'Actions', value: 'action', sortable: false}
        ],
        items: [

        ],
        dateFrom: null,
        dateTo: null,
        receiveNo: '',
        receiver: '',
        rules: {
            required: value => !!value || 'Required.'
        },
        itemId: ''
    }),
    methods: {
        setDateFrom(val) {
            this.dateFrom = val;
        },
        setDateTo(val) {
            this.dateTo = val;
        },
        search() {
            this.dateFrom = this.dateFrom.replace("/", "-").replace("/", "-");
            this.dateTo = this.dateTo.replace("/", "-").replace("/", "-");
            listStockPartsByReceiveNo(this.dateFrom, this.dateTo, this.receiveNo, this.branchCode).then(rs => {
                this.items = rs;
                if (this.items) {
                    this.items.forEach(o => {
                        o.netAmountDisplay = numeral(o.netAmount).format('0,0.00');
                    });
                }
            });
        },
          editData(item) {
            this.itemId = item.receivePartsId;
            this.viewDialog = true;
            this.$nextTick(() => {
                this.$refs.viewParts.show(item.receivePartsId);
            });
            
        },
        deleteData(item) {
            if (confirm('ต้องการลบ ' + item.receiveNo + ' ใช่หรือไม่ ?')) {
                deleteStockParts(item.receivePartsId).then(() => {
                    const index = this.items.indexOf(item);
                    this.items.splice(index, 1);
                });
            }
        },
        deleteSelected() {
            if (confirm('ต้องการลบข้อมูลจำนวน ' + this.selectedItem.length + ' รายการ ใช่หรือไม่ ?')) {
                this.selectedItem.forEach(o => {
                    deleteStockParts(o.receivePartsId).then(() => {
                        const index = this.items.indexOf(o);
                        this.items.splice(index, 1);
                    });
                });
                this.selectedItem = [];
                //this.search();
            }
        },
        closeViewParts() {
            this.viewDialog = false;
            this.search();
        }
    }
}
</script>